import { render } from "./IntroComponent.vue?vue&type=template&id=bdd6c352&scoped=true"
const script = {}

import "./IntroComponent.vue?vue&type=style&index=0&id=bdd6c352&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd6c352"]])

export default __exports__